


















































import { mapActions, mapGetters } from 'vuex';

import { AlignEnum, ApiEnum, KpiEnum, QueriesTypeEnum } from '../../../enums';

import { capitalizeSentence } from '../../../filters';

import { DataTableColumn, Pagination } from '../../../models';

import { ANALYTICS_CONSTS } from '../../../store/analytics/analytics.consts';
import { CONFIG_CONSTS } from '../../../store/config/config.consts';

import DataTable from '../../crud/data-table.component.vue';
import PaginationBar from '../../crud/pagination-bar.component.vue';
import KpiBar from '../../kpi-bar.component.vue';
import Tabs from '../../tabs.component.vue';

export default {
  name: 'queries-table',
  components: {
    DataTable,
    KpiBar,
    PaginationBar,
    Tabs
  },
  computed: {
    ...mapGetters(ANALYTICS_CONSTS.moduleName, {
      data: ANALYTICS_CONSTS.getters.data,
      selectedId: ANALYTICS_CONSTS.getters.selectedId
    }),
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      kpis: CONFIG_CONSTS.getters.kpis
    }),
    queriesTypeTabs: function (): any[] {
      return Object.values(QueriesTypeEnum).map((queryType) =>
        ({
          id: queryType,
          text: this.messages.queries.queriesTypes[queryType]
        }));
    },
    columns: function (): Object[] {
      const kpisMessages = this.messages.kpis;
      const columns: DataTableColumn[] = [
        {
          id: 'terms',
          text: capitalizeSentence(this.messages.queryName),
          width: '200%'
        },
        {
          id: 'queryCount',
          text: capitalizeSentence(this.messages.quantity),
          align: AlignEnum.END
        }
      ];
      if (this.selectedQueriesType === QueriesTypeEnum.ALL) {
        columns.push({
          id: 'queryCountNoResults',
          text: capitalizeSentence(kpisMessages.noResults.valueLabel),
          align: AlignEnum.END
        });
      }
      if (this.selectedQueriesType !== QueriesTypeEnum.WITHOUT_RESULTS) {
        if (this.kpis.includes(KpiEnum.CLICKS)) {
          columns.push(
            {
              id: 'clickCountPct',
              text: capitalizeSentence(kpisMessages.clicks.percentageLabel),
              align: AlignEnum.END
            });
          columns.push(
            {
              id: 'firstPageCountPct',
              text: capitalizeSentence(kpisMessages.findability.percentageLabel),
              align: AlignEnum.END
            });
        }
        if (this.kpis.includes(KpiEnum.ADD2CART)) {
          columns.push(
            {
              id: 'add2cartCountPct',
              text: capitalizeSentence(kpisMessages.add2cart.percentageLabel),
              align: AlignEnum.END
            });
        }
        if (this.kpis.includes(KpiEnum.CHECKOUT)) {
          columns.push(
            {
              id: 'checkoutCount',
              text: capitalizeSentence(kpisMessages.checkout.valueLabel),
              align: AlignEnum.END
            });
        }
      }
      columns.push(
        {
          id: 'volume',
          text: capitalizeSentence(this.messages.volume),
          width: '13rem',
          align: AlignEnum.CENTER
        });
      return columns;
    },
    queriesData: function (): any[] {
      const queriesData = this.data.queries[this.selectedQueriesType];
      return ((!!queriesData && queriesData.data) || []);
    }
  },
  data: function () {
    return {
      selectedQueriesType: QueriesTypeEnum.ALL,
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      },
      itemsPerPageOptions: [10, 50, 100, 200],
      percentageKpis: ['clickCountPct', 'firstPageCountPct', 'add2cartCountPct'],
      maxValueToCompare: 0,
      loading: false,
      messages: this.$epb.messages.analytics,
      QueriesTypeEnum
    };
  },
  methods: {
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      loadQueriesData: ANALYTICS_CONSTS.actions.loadQueriesData
    }),
    loadData: async function ({ resetPagination, resetAll } = { resetPagination: false, resetAll: false }): Promise<void> {
      if (resetPagination || resetAll) {
        this.pagination.page = 1;
      }
      if (resetAll) {
        this.selectedQueriesType = QueriesTypeEnum.ALL;
      }
      this.loading = true;
      try {
        const queriesData = await this.loadQueriesData({ type: this.selectedQueriesType, pagination: this.pagination });

        if (this.pagination.page === 1 && this.selectedQueriesType === QueriesTypeEnum.ALL && !!queriesData.data.length) {
          this.maxValueToCompare = queriesData.data[0].queryCount;
        }
        this.pagination.totalItems = queriesData.termsCount;
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.STATS));
      } finally {
        this.loading = false;
      }

    },
    getPercentageKpiText: function (kpi: any): string {
      return `${ kpi.toLocaleString(this.$epb.locale, { maximumFractionDigits: 2 }) }%`;
    },
    getQueriesBar: function (dataItem: any) {
      const kpiId = this.selectedQueriesType !== QueriesTypeEnum.WITHOUT_RESULTS ? KpiEnum.QUERIES : KpiEnum.NO_RESULTS;
      return {
        id: kpiId,
        label: this.messages.volume,
        percentage: (Math.round(dataItem.queryCount / this.maxValueToCompare * 1000) / 10)
      };
    },
    onSelectionChange: function (selection: any[]): void {
      this.$emit('querySelected', (selection[0] || []).terms);
    },
    onPaginationChange: function (pagination: Pagination): void {
      this.pagination = pagination;
      this.loadData();
    },
    onDownload: async function (pagination: Pagination): Promise<void> {
      this.$emit('updateLoading', { visible: true });
      try {
        await this.loadQueriesData({ type: this.selectedQueriesType, pagination: pagination, download: true });
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.STATS));
      } finally {
        this.$emit('updateLoading', { visible: false });
      }
    }
  },
  watch: {
    selectedQueriesType: function () {
      this.$refs.queriesTableContainer.scrollLeft = 0;
      this.loadData({ resetPagination: true });
    },
    pagination: {
      deep: true,
      handler: function () {
        this.$refs.queriesTableContainer.scrollLeft = 0;
      }
    }
  }
};

